export default [
  {
    name: 'unit-swapping',
    path: '/units/swapping/edit',
    component: () => import('@/views/units/unit-swapping/UnitSwappingWizard')
  },
  {
    name: 'unit-swapping-pre-set',
    path: '/units/swap/partner/:partner_id/agency/:agency_id/client/:client_id/unit/:unit_id/vehicle/:vehicle_id',
    component: () => import('@/views/units/unit-swapping/UnitSwappingWizard')
  }
]



// WEBPACK FOOTER //
// ./src/router/routeUnitsSwapping.js